import { render, staticRenderFns } from "./ChooseOverUnderModal.vue?vue&type=template&id=90d0b466&"
import script from "./ChooseOverUnderModal.vue?vue&type=script&lang=js&"
export * from "./ChooseOverUnderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports